<div class="container-fluid mt-4">
  <h2 class="mb-3">{{'PROFILE.TITLE' | translate}}</h2>

  @if (loading) {
    <p class="text-muted">{{'PROFILE.LOADING' | translate}}</p>
  } @else {
    <div style="max-width: 640px;">

      <!--
        The avatar is the thing being edited, so it is shown as it will look
        once saved rather than as it looks now: picking a swatch is otherwise a
        guess about a 30px circle elsewhere on the screen.
      -->
      <div class="d-flex align-items-center gap-3 mb-4">
        <app-user-avatar [user]="preview" size="lg"></app-user-avatar>
        <div>
          <div class="fw-semibold">{{user?.username}}</div>
          <div class="form-text">{{'PROFILE.USERNAME_HELP' | translate}}</div>
        </div>
      </div>

      <form (ngSubmit)="save()" #profileForm="ngForm">

        <div class="mb-3">
          <label class="form-label" for="profile-name">{{'PROFILE.NAME' | translate}}</label>
          <input type="text" class="form-control" id="profile-name" name="name"
                 maxlength="60" [(ngModel)]="name" #nameField="ngModel">
          <div class="form-text">{{'PROFILE.NAME_HELP' | translate}}</div>
        </div>

        <div class="mb-4">
          <label class="form-label" for="profile-surname">{{'PROFILE.SURNAME' | translate}}</label>
          <input type="text" class="form-control" id="profile-surname" name="surname"
                 maxlength="60" [(ngModel)]="surname" #surnameField="ngModel">
        </div>

        <!--
          A fieldset with a legend, not a <label>: a label names one control and
          this is a group of buttons. Each swatch is a real <button> so it is
          reachable by keyboard, and carries the colour name in its label since
          the colour itself says nothing to a screen reader.
        -->
        <fieldset class="mb-4">
          <legend class="form-label h6 mb-1">{{'PROFILE.AVATAR_COLOR' | translate}}</legend>
          <div class="form-text mb-2">{{'PROFILE.AVATAR_COLOR_HELP' | translate}}</div>

          <div class="d-flex flex-wrap gap-2">
            @for (color of colors; track color) {
              <button type="button" class="avatar-swatch"
                      [class.avatar-swatch--selected]="avatarColor === color"
                      [style.background-color]="color"
                      [attr.aria-pressed]="avatarColor === color"
                      [attr.aria-label]="('PROFILE.AVATAR_COLOR' | translate) + ' ' + color"
                      (click)="chooseColor(color)"></button>
            }
          </div>

          @if (usingDerivedColor) {
            <div class="form-text mt-2">{{'PROFILE.AVATAR_COLOR_AUTO' | translate}}</div>
          }
        </fieldset>

        <button type="submit" class="btn btn-primary" [disabled]="saving">
          {{'PROFILE.SAVE' | translate}}
        </button>
      </form>
    </div>
  }
</div>
